import eVerify from './e-verify.png';

const EVerifyLogo = (): JSX.Element => (
    <img alt="E-verify" src={eVerify} />
);

export default EVerifyLogo;